/*
 * @Author: Chris 
 * @Date: 2022-07-29 14:35:59 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-08 16:06:37
 */
  
<template>
  <div class="organize" v-loading="treeLoading">
    <div class="organize_tree">
      <div class="organize_tree_filter">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          @change="handleFilter">
        </el-input>
      </div>
      <div
        :class="['organize_tree_in', index ? '' : 'organize_tree_in0']"
        v-for="(item, index) in organizationTree"
        :key="item.companyId"
      >
        <el-tree
          :ref="'tree_' + index"
          :data="item"
          node-key="deptId"
          :props="defaultProps"
          :highlight-current="true"
          :default-expand-all="true"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          @current-change="currentchange"
        >
          <template slot-scope="{ data }">
            <div
              class="tree_in"
              :class="data.type == 'company' ? 'tree_in_first' : ''"
            >
              <div class="in_first">
                <el-image
                  class="in_logo"
                  v-if="data.type == 'company'"
                  :src="Headerimg"
                  alt=""
                />
                <div
                  :class="data.type == 'company' ? 'companyName' : ''"
                  class="in_first_name"
                >
                  {{ data.deptName }}
                </div>
              </div>
              <div class="in_popover" @click="adddep(data)">
                添加子部门
                <el-image class="add_icon" :src="addICON"></el-image>
              </div>
            </div>
          </template>
        </el-tree>
      </div>
    </div>

    <!-- 新增部门  -->

    <Adddepartment :deptId="deptId"></Adddepartment>
  </div>
</template>
  
<script>
import { authdeptlist } from "../../../api/api";
import Adddepartment from "../components/adddepartment.vue";
import Headerimg from "../../../assets/IMG/organization/compny.png";
import addICON from "../../../assets/IMG/organization/Groupadd.png";
export default {
  name: "organize",
  components: { Adddepartment },
  data() {
    return {
      treeLoading: false,
      Headerimg: Headerimg,
      addICON: addICON,
      deptId: "", //新增时候的ID
      treeKey: null, //选中的key
      choosedeptId: null,
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      organizationTree: [],
      constOrganizationTree: [],

      filterText: ''
    };
  },

  mounted() {
    this.getTree();
  },

  watch: {
    /**
     * 监听vuex数据，刷新列表
     * */

    "$store.state.Refresh_Organize"(e) {
      this.getTree();
    },
  },

  methods: {
    /**
     * 打开新增部门
     * */

    adddep(e) {
      this.deptId = e.deptId;
      this.$store.commit("SET_Drawer_Department_Add", true);
    },

    /**
     * 获取组织树
     * */

    async getTree() {
      this.treeLoading = true;
      this.organizationTree = [];
      this.constOrganizationTree = [];
      let res = await authdeptlist().catch(() => {
        this.treeLoading = false;
      });
      if (res.code == 200) {
        for (let i in res.data) {
          this.organizationTree.push([res.data[i]]);
        }
        if (!this.choosedeptId || this.$store.state.Refresh_Organize) {
          this.handleNodeClick(this.organizationTree[0][0]);
          this.$nextTick(() => {
            this.$refs.tree_0[0].setCurrentKey(
              this.organizationTree[0][0].deptId
            );
          });
        }

        /**
         * 如果是修改部门，那么还是停留在该部门
         * */

        if (this.$store.state.EditDepartmentInformation) {
          this.$nextTick(() => {
            this.$refs.tree_0[0].setCurrentKey(
              this.$store.state.EditDepartmentInformation
            );
          });
        }
        this.constOrganizationTree = [...this.organizationTree]
      }
      this.treeLoading = false;
    },

    handleFilter(){
      this.organizationTree = []
      for(let item of this.constOrganizationTree) {
        if (item[0].deptName.indexOf(this.filterText) >= 0) {
          this.organizationTree.push(item)
        }
      }
    },

    /**
     * 点击组织树
     * */

    handleNodeClick(e) {
      for (let i in this.organizationTree) {
        if (this.organizationTree[i][0].companyId == e.companyId) {
          this.choosedeptId = this.organizationTree[i][0].deptId;
          break;
        }
      }
      this.$emit("chooseOrg", e);
    },

    currentchange(e, w) {
      for (let i in this.organizationTree) {
        let name = "tree_" + [i];
        this.$refs[name][0].setCurrentKey(null);
        this.$refs[name][0].setCurrentKey(e.deptId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.organize {
  width: 100%;
  user-select: none;
  cursor: pointer;
  .organize_header {
    height: 3.375rem;
    border-bottom: 0.125rem solid #eee;
    display: flex;
    align-items: flex-start;
  }
  .organize_tree {
    // padding: 0 0.625rem 0 0;
    box-sizing: border-box;
    overflow-y: auto;
    // height: 75vh;
    // height: 840px;
    height: calc(100vh - 146px);
    .organize_tree_filter {
      margin-bottom: 10px;
    }

    .organize_tree_in {
      margin: 0.625rem 0;
    }
    .organize_tree_in0 {
      margin: 0;
    }

    .tree_in {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 1.25rem;
      color: #3e3a39;

      .in_first {
        display: flex;
        align-items: center;
        .in_first_name {
          min-width: 0;
          width: 15rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .in_logo {
        border-radius: 0.25rem;
        margin-right: 0.5rem;
        width: 1.25rem;
        height: 1.25rem;
      }

      .right_more {
        padding-right: 0.9375rem;
      }
    }
  }
}

.popover_in {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  .in_button {
    user-select: none;
    cursor: pointer;
    height: 1.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    line-height: 1.25rem;
    color: #333333;
  }
  :hover {
    color: #b7282d;
    background: rgba($color: #b7282d, $alpha: 0.1);
  }
}

.organize :deep(.el-tree-node__content) {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.5625rem;
  color: #333333;
  padding: 0.3125rem 0;
  height: 1.3125rem;
}

.companyName {
  font-size: 0.875rem;
}

.organize :deep(.el-tree-node__content:has(.tree_in_first)) {
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5625rem;
  color: #333333;
  padding: 0.3125rem 0;
  height: 1.875rem !important;
}

.organize
  :deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
  ) {
  background: linear-gradient(
    90deg,
    rgba(183, 40, 45, 0.3) 0%,
    rgba(183, 40, 45, 0.018) 99.4%
  );
  border-radius: 0.25rem;
}

.organize
  :deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .in_first_name
  ) {
  width: 10rem;
}

.organize
  :deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .in_popover
  ) {
  width: 7rem;
  height: 1.875rem;
  color: #b7282d;
  display: flex;
  align-items: center;
  justify-content: center;
  .add_icon {
    width: 1rem;
    height: 1rem;
    margin-left: 0.25rem;
  }
}

.in_popover {
  display: none;
}

.organize
  :deep(
    .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content
      .in_first
  ) {
  font-weight: 600;
}
</style>